import * as amplitude from '@amplitude/analytics-browser';
import { environment } from '@env/environment';
import { EventTrackerAdapter } from '../event-tracker.adapter';
import { DeviceStore } from '@app/store/device';
import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class AmplitudeAdapter implements EventTrackerAdapter {
  constructor(private deviceStore: DeviceStore) {}

  init() {
    amplitude.init(environment.AMPLITUDE_KEY);
  }

  async track<T extends Partial<T>>(eventName: string, eventData?: T) {
    const payload: any = {
      project: 'current',
      device: this.deviceStore.getDeviceType(),
      application: this.deviceStore.getApplication(),
      ...eventData,
    };

    amplitude.track(eventName, payload);
  }

  setUserId(id: string): void {
    amplitude.setUserId(id);
  }
}
